import "../scss/app.scss";
import * as Form from "./form";

document.addEventListener("DOMContentLoaded", (event) => {
  Form.init(document);
});
